import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

interface ListingProps {
  pageNo: number;
}

const GetComplaintsService = ({ pageNo }: ListingProps) => {
  return HTTP_CLIENT.get(Endpoint.general.listComplaints + `?pageNo=${pageNo}`);
};

const GetUsersListService = (orgId: string) => {
  return HTTP_CLIENT.get(Endpoint.general.listUsers + `?orgId=${orgId}`);
};

const GetOptionsListService = () => {
  return HTTP_CLIENT.get(Endpoint.general.listOptions);
};

const GetCountService = () => {
  return HTTP_CLIENT.get(Endpoint.general.count);
};

const DeleteComplaintService = (id: any) => {
  return HTTP_CLIENT.delete(
    Endpoint.general.deleteComplaint.replace(":id", id)
  );
};

const UploadFile = (payload: any) => {
  return HTTP_CLIENT.post(Endpoint.general.uploadFile, payload);
};

export {
  GetComplaintsService,
  GetUsersListService,
  GetOptionsListService,
  DeleteComplaintService,
  GetCountService,
  UploadFile,
};
